/*
  Convert a phone-number string from the BE into canonical E.164 ("+…") so
  it can drive `<cf-phone-number-input>` as a v-model value.

  Three shapes are accepted, mirroring `format-phone-for-display.js`:

    "+14155555510"  → "+14155555510" — already canonical, pass through.
    "14155555510"   → "+14155555510" — wire format used by new submits.
    "4155555510"    → "+14155555510" — legacy US-only data; assume US.

  Returns null for empty / unparseable input. The caller decides whether
  unparseable means "show empty form" or "show an error."
*/

const LEGACY_BARE_US_LENGTH = 10;

export default function parsePhoneFromApi(value) {
  if (value == null || value === '') return null;

  const stringValue = String(value).trim();

  if (!stringValue) return null;

  if (stringValue.startsWith('+')) return stringValue;

  const digits = stringValue.replace(/\D/g, '');

  if (!digits) return null;

  if (digits.length === LEGACY_BARE_US_LENGTH) {
    return `+1${digits}`;
  }

  return `+${digits}`;
}
